export default __webpack_public_path__ + "static/media/tl.a7280e3f.svg";